/**
 * Enum representing the different types of accounts in the system.
 * Used to categorize accounts based on their purpose and access levels.
 */
export enum AccountTypeEnum {
  /**
   * Standard user account for hotel staff and administrators.
   */
  user = 'user',

  /**
   * Service account used for system integrations and automated processes.
   */
  service = 'service',

  /**
   * Visitor account for hotel guests and temporary users.
   */
  visitor = 'visitor',
}
